import { useMutation, useQuery } from "@tanstack/react-query";
import { authService } from "./mfa.api";
import { useAuth } from "context/auth-context";

/* 🔐 SETUP */
export const useGenerateMfa = () =>
  useMutation({
    mutationFn: (email: string) =>
      authService.generateMfaSecret(email),
  });

/* ✅ VERIFY */
export const useVerifyMfa = () =>
  useMutation({
    mutationFn: (data: { email: string; token: string }) =>
      authService.verifyMfa(data),
  });

/* 🔐 LOGIN */
export const useMfaLogin = () =>
  useMutation({
    mutationFn: authService.loginVerifyMfa,
  });

/* ❌ DISABLE */
export const useDisableMfa = () =>
  useMutation({
    mutationFn: authService.disableMfa,
  });

/* 📊 STATUS (IMPORTANT FIX) */
export const useMfaStatus = () => {
  const { auth } = useAuth();

  return useQuery({
    queryKey: ["mfa-status", auth?.email],
    queryFn: () => authService.getMfaStatus(auth?.email),
    enabled: !!auth?.email,
  });
};

/* 🔁 REGENERATE */
export const useRegenerateBackupCodes = () =>
  useMutation({
    mutationFn: (email: string) =>
      authService.regenerateBackupCodes(email),
  });

/* ============================= */
/* 📄 GET BACKUP CODES */
/* ============================= */

export const useBackupCodes = () => {
  const { auth } = useAuth();

  return useQuery({
    queryKey: ["backup-codes", auth?.email],
    queryFn: () => authService.getBackupCodes(auth?.email),
    enabled: !!auth?.email,
  });
};

/* ============================= */
/* 📩 REQUEST MFA RECOVERY */
/* ============================= */

export const useMfaRecovery = () => {
  return useMutation({
    mutationFn: authService.requestMfaRecovery,
  });
};

/* ============================= */
/* 🛠 ADMIN RESET MFA */
/* ============================= */

export const useResetMfa = () => {
  return useMutation({
    mutationFn: authService.resetUserMfa,
  });
};  